import SEOHead from "@/components/layout/SEOHead";
import { PageHero } from "@/pages/About.hero";
import { ExternalLink, Calendar as CalendarIcon } from "lucide-react";
import { Link } from "react-router-dom";

// TIOB office Google Calendar (tiofficesue@gmail.com) - public read view.
// Switch to this via admin → content block "events.google_calendar_src" if the
// account ever moves.
const CAL_SRC = "tiofficesue@gmail.com";
const CAL_TZ = "America/New_York";
const EMBED_URL =
  `https://calendar.google.com/calendar/embed?src=${encodeURIComponent(CAL_SRC)}` +
  `&ctz=${encodeURIComponent(CAL_TZ)}&mode=MONTH&showPrint=0&showTabs=1&showCalendars=0`;
const SUBSCRIBE_URL =
  `https://calendar.google.com/calendar/u/0/r?cid=${encodeURIComponent(CAL_SRC)}`;

export default function Events() {
  return (
    <>
      <SEOHead
        title="Events at Temple Israel of Brevard"
        description="Browse the full Temple Israel of Brevard calendar - services, holidays, classes, bingo, BBQs and all community events in one place."
        path="/events"
      />
      <PageHero
        eyebrow="Upcoming Events"
        title="Events at TIOB"
        subtitle="The full TIOB calendar - services, holidays, classes, social events and more. Click any event for details."
      />

      <section className="bg-white py-10 lg:py-14">
        <div className="max-w-6xl mx-auto px-5 lg:px-10">
          {/* Google Calendar embed */}
          <div
            className="relative rounded-2xl overflow-hidden border border-[var(--line)] shadow-lg bg-white"
            data-testid="events-google-calendar-wrap"
          >
            <iframe
              title="Temple Israel of Brevard - full event calendar"
              src={EMBED_URL}
              className="w-full block"
              style={{ height: "min(80vh, 820px)", border: 0 }}
              loading="lazy"
              data-testid="events-google-calendar"
            />
          </div>

          {/* Action row */}
          <div className="mt-6 flex flex-wrap items-center gap-3 justify-center">
            <a
              href={SUBSCRIBE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
              data-testid="events-subscribe-google"
            >
              <CalendarIcon size={16} /> Add to Google Calendar <ExternalLink size={14} />
            </a>
            <Link to="/calendar/month" className="btn-ghost" data-testid="events-link-monthly">
              Monthly view
            </Link>
            <Link to="/calendar/weekly" className="btn-ghost" data-testid="events-link-weekly">
              This week at TIOB
            </Link>
          </div>

          <p className="text-xs text-[var(--muted)] text-center mt-8">
            Having trouble seeing the calendar?{" "}
            <a
              href={EMBED_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[var(--blue-deep)] underline"
            >
              Open it in a new tab
            </a>
            . To submit an event, email{" "}
            <a
              href="mailto:tioffice@tiofbrevard.com"
              className="text-[var(--blue-deep)] underline"
            >
              tioffice@tiofbrevard.com
            </a>
            .
          </p>
        </div>
      </section>
    </>
  );
}
